import Title from "../../../Universal/Title.component";
import DeleteBtnIcon from "../../../../assets/Icons/Universal/DeleteIcon.svg";
import "../../../../styles/ComponentsStyles/Setting/Profile/AdminInfo.style.css";
const AdminInfo = ({ data }) => {
  return (
    <div className="w-full flex-col align-start justify-start g-1 w-full h-full">
      <Title className="color-textGray">
        This is admin profile details. It is an authentication head for any
        institute.
      </Title>
      <div className="w-full flex-row align-start justify-start g-2 back-white radius-10 flex-1 p-3">
        {/* admin profile details left side */}
        <div className="flex-col align-center justify-start g-2">
          <Title>Admin info</Title>
          <div className="flex-col align-center justify-start g-05">
            <div
              className="p-05 radius-6 border-2-greenBack"
              style={{ width: "8rem", height: "8rem" }}
            >
              <img src={data?.profileImage} className="w-full h-full" alt="" />
            </div>
            <span className="poppins t-14 color-grayColor">ID: {data?.id}</span>
          </div>
          <div
            className="p-05 radius-6 border-2-greenBack"
            style={{ width: "8rem", height: "8rem" }}
          >
            <img src={data?.signature} className="w-full h-full" alt="" />
          </div>
          <div className="flex-col align-start justify-start g-03 w-fit">
            <span className="poppins t-12 color-black">Position color</span>
            <div
              className="radius-6"
              style={{
                width: "8rem",
                height: "3.5rem",
                background: data?.positionColor,
              }}
            ></div>
          </div>
        </div>

        {/* another account details */}
        <div className="flex-col align-start justify-start g-3 w-full">
          {/* account all details top  */}
          <div className="flex-row align-center justify-between w-full">
            {/* gender selection button (only view) */}
            <div className="flex-row align-center justify-start g-05 toggleBtn">
              <span>{data?.gender}</span>
              <input
                type="radio"
                name="gender"
                checked={data?.gender === "Male"}
              />
            </div>
            <button type="button" className="transparentBtn">
              <img src={DeleteBtnIcon} alt="delete button" />
            </button>
          </div>
          <div className="settingAdminProfileDetails">
            <div className="flex-row align-center justify-start g-05">
              <span className="t-14 poppins color-textGray">Name:</span>
              <span className="t-14 poppins color-black">{data?.name}</span>
            </div>
            <div className="flex-row align-center justify-start g-05">
              <span className="t-14 poppins color-textGray">Phone:</span>
              <span className="t-14 poppins color-black">{data?.phone}</span>
            </div>
            <div className="flex-row align-center justify-start g-05">
              <span className="t-14 poppins color-textGray">Email:</span>
              <span className="t-14 poppins color-black">{data?.email}</span>
            </div>
            <div className="flex-row align-center justify-start g-05">
              <span className="t-14 poppins color-textGray">Designation:</span>
              <span className="t-14 poppins color-black">
                {data?.designation}
              </span>
            </div>
            <div className="flex-row align-center justify-start g-05">
              <span className="t-14 poppins color-textGray">Relationship:</span>
              <span className="t-14 poppins color-black">
                {data?.relationship}
              </span>
            </div>
            <div className="flex-row align-center justify-start g-05">
              <span className="t-14 poppins color-textGray">
                Working field:
              </span>
              <span className="t-14 poppins color-black">
                {data?.workingField}
              </span>
            </div>
            <div className="flex-row align-center justify-start g-05">
              <span className="t-14 poppins color-textGray">Salary:</span>
              <span className="t-14 poppins color-black">₹{data?.salary}</span>
            </div>
            <div className="flex-row align-center justify-start g-05">
              <span className="t-14 poppins color-textGray">Reporting to:</span>
              <span className="t-14 poppins color-black">
                {data?.reportingTo}
              </span>
            </div>
            <div className="flex-row align-center justify-start g-05">
              <span className="t-14 poppins color-textGray">Experience:</span>
              <span className="t-14 poppins color-black">
                {data?.experience}
              </span>
            </div>
            <div className="flex-row align-center justify-start g-05">
              <span className="t-14 poppins color-textGray">
                Experrience field:
              </span>
              <span className="t-14 poppins color-black">
                {data?.experienceField}
              </span>
            </div>
            <div className="flex-row align-center justify-start g-05">
              <span className="t-14 poppins color-textGray">Address:</span>
              <span className="t-14 poppins color-black">{data?.address}</span>
            </div>
            <div className="flex-row align-center justify-start g-05">
              <span className="t-14 poppins color-textGray">Aadhaar no:</span>
              <span className="t-14 poppins color-black flex-row align-center justify-start g-01">
                <span>{data?.aadhaarNumber}</span>
              </span>
            </div>
          </div>
          <button type="button" className="actionBtn w-full">
            Edit profile
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminInfo;
